export default __webpack_public_path__ + "static/oreo-logo-background-1dd5b03913a93d3e03b4bb0b4f089c86.png";